"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueSetResolver = void 0;
var axios_1 = __importDefault(require("axios"));
var VSACHelper_1 = require("./VSACHelper");
var ValueSetResolver = /** @class */ (function () {
    function ValueSetResolver(apiKey) {
        this.apiKey = apiKey;
        this.instance = axios_1.default.create({
            headers: {
                Accept: 'application/fhir+json',
                Authorization: "Basic " + this.authHeaderValue()
            },
            // Timeout is in ms, not seconds
            timeout: 60000,
            withCredentials: true
        });
    }
    ValueSetResolver.prototype.authHeaderValue = function () {
        return Buffer.from("apikey:" + this.apiKey).toString('base64');
    };
    ValueSetResolver.prototype.getExpansionForValuesetUrls = function (urls) {
        return __awaiter(this, void 0, void 0, function () {
            var valuesets, errors, _i, urls_1, url, normalizedUrl, res, e_1, missingValuesets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        valuesets = [];
                        errors = [];
                        _i = 0, urls_1 = urls;
                        _a.label = 1;
                    case 1:
                        if (!(_i < urls_1.length)) return [3 /*break*/, 6];
                        url = urls_1[_i];
                        normalizedUrl = url;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        // Use known good base for VSAC urls
                        if (VSACHelper_1.isVSACUrl(url)) {
                            normalizedUrl = VSACHelper_1.normalizeCanonical(url) || url;
                        }
                        return [4 /*yield*/, this.instance.get(normalizedUrl + "/$expand")];
                    case 3:
                        res = _a.sent();
                        valuesets.push(res.data);
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        errors.push("Valueset with URL " + normalizedUrl + " could not be retrieved. Reason: " + e_1.message);
                        return [3 /*break*/, 5];
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        // If we couldn't retrieve any valuesets, return and let the user know
                        if (errors.length > 0) {
                            return [2 /*return*/, [valuesets, errors]];
                        }
                        missingValuesets = this.findMissingValuesets(urls, valuesets);
                        return [2 /*return*/, [valuesets, missingValuesets]];
                }
            });
        });
    };
    ValueSetResolver.prototype.findMissingValuesets = function (missingVSURLs, expansions) {
        var stillMissingValuesets = __spreadArrays(missingVSURLs);
        // remove any valuesets we got from their URLs from the "missing" list
        expansions.forEach(function (vs) {
            if (vs.url) {
                var index = stillMissingValuesets.indexOf(vs.url);
                if (index > -1) {
                    stillMissingValuesets.splice(index, 1);
                }
            }
        });
        return stillMissingValuesets;
    };
    return ValueSetResolver;
}());
exports.ValueSetResolver = ValueSetResolver;
//# sourceMappingURL=ValueSetResolver.js.map